<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <locality-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import LocalityProvider from "../../../../providers/LocalityProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import LocalityForm from "../LocalityForm";
  
    

    export default {
        name: "LocalityUpdate",
        
        components: { LocalityForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'maps.locality.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    locality: this.item.locality
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    LocalityProvider.updateLocality(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateLocality)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

